import React from 'react'
import { Link } from 'react-router-dom'
import Constant from '../../Constant'
import Swal from 'sweetalert2'
import axios from 'axios'
import MUIDataTable from 'mui-datatables'
import Loader from '../../common/Loader'
import 'react-responsive-modal/styles.css'
import { Modal } from 'react-responsive-modal'

import 'react-toggle/style.css' // for ES6 modules
import Toggle from 'react-toggle'
import ActivitiesController from '../../common/activitiesController/ActivitiesController'

class TripList extends React.Component {
  state = {
    list: [],
    isListLoading: false,
    isEditingOrderNumber: false,
    editingOrderNumberId: null,
    isModalOpen: false,
    pushId: '',
    pushTitle: '',
    pushMessage: '',
  }

  componentDidMount() {
    this.loadAllData()
  }

  loadAllData = async () => {
    this.setState({
      isListLoading: true,
    })

    await axios
      .get(Constant.getAPI() + '/admin/trip', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.success) {
          this.setState({
            list: res.data.data,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isListLoading: false,
        })
      })
  }

  delete = async (id) => {
    await axios
      .delete(Constant.getAPI() + '/admin/trip/' + id, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.data.statusCode === 200) {
          Swal.fire({
            title: 'Deleted Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })

          this.setState({
            list: this.state.list.filter((item) => item.id !== id),
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onOrderNumberEdit = (id, order) => {
    this.setState({
      editingOrderNumberId: id,
      editingOrderValue: order,
      isEditingOrderNumber: true,
    })
  }

  onOrderNumberSave = async () => {
    if (this.state.editingOrderNumberId && this.state.editingOrderValue) {
      axios
        .put(
          Constant.getAPI() + '/admin/trip/' + this.state.editingOrderNumberId,
          {
            order: this.state.editingOrderValue,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
              country_short_name: `${localStorage.getItem('countryShortName')}`,
            },
          }
        )
        .then((data) => {
          if (data.status === 200 && data.data) {
            let tempList = this.state.list

            tempList.forEach((item) => {
              if (item.id === this.state.editingOrderNumberId) {
                item.order = this.state.editingOrderValue
              }
            })

            this.setState({
              list: tempList,
              editingOrderNumberId: null,
              editingOrderValue: null,
              isEditingOrderNumber: false,
            })
          }
        })
        .catch((err) => {
          if (err?.response?.status === 401) {
            Constant.getAuthLogout()
          } else {
            Swal.fire({
              title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
              icon: 'error',
              text: '',
              type: 'error',
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Ok',
            })
          }
        })
    } else {
      this.setState({
        editingOrderNumberId: null,
        editingOrderValue: null,
        isEditingOrderNumber: false,
      })
    }
  }

  onOrderNumberChange = ({ target: { name, value } }) => {
    this.setState({ [name]: value })
  }

  // onPushClick = (id, metaData) => {
  //   this.setState({
  //     isModalOpen: true,
  //     pushTitle: metaData.rowData[2].slice(0, 22),
  //     pushId: id,
  //   })
  // }

  onModalClose = () => {
    this.setState({
      pushId: '',
      pushTitle: '',
      pushMessage: '',
      isModalOpen: false,
    })
  }

  sendPush = () => {
    this.setState({ isData: true })

    if (!this.state.pushTitle || !this.state.pushMessage) {
      Swal.fire({
        title: 'Error',
        icon: 'error',
        text: 'All fields are required...',
        type: 'error',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Ok',
      })

      this.setState({ isData: false })
      return
    }

    const data = {
      pushTitle: this.state.pushTitle,
      message: this.state.pushMessage,
      type: 'T',
      typeId: this.state.pushId,
    }

    axios
      .post(Constant.getAPI() + '/admin/send-push', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        this.setState({ isData: false })
        if (res.status) {
          Swal.fire({
            title: 'Notification sent Successfully!',
            icon: 'success',
            text: '',
            type: 'success',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
          this.onModalClose()
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  handleChange = (event) => {
    this.setState({ [event.target.name]: event.target.value })
  }

  handleStatusChange = async (id, isActive) => {
    var data = {
      is_active: isActive,
    }

    await axios
      .put(Constant.getAPI() + '/admin/trip/' + id, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Updated !', 'Status has been Changed', 'success')
          this.loadAllData()
        }
      })
      .catch((err) => {
        this.setState({ isData: false })
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  render() {
    const columns = [
      {
        name: 'id',
        label: 'id',
        options: {
          filter: false,
          sort: true,
          display: false,
        },
      },
      {
        name: 'order',
        label: 'Order No.',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (order, tableMeta) => {
            var id = tableMeta.rowData[0]
            return (
              <div className="form-group">
                <div className="form-group">
                  {this.state.isEditingOrderNumber && this.state.editingOrderNumberId === id ? (
                    <div className="input-group mb-3">
                      <input
                        type="number"
                        name="editingOrderValue"
                        className="form-control form-control-sm p-l-15"
                        style={{ width: '50px' }}
                        onChange={this.onOrderNumberChange}
                        value={this.state.editingOrderValue}
                      />
                      <div className="input-group-append border">
                        <span
                          onClick={this.onOrderNumberSave.bind(this, id)}
                          className="input-group-text d-flex justify-content-center align-items-center shadow-sm"
                        >
                          <i className="f-20 bg-white p-2 icofont icofont-ui-check"></i>
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div className="input-group mb-3">
                      <div
                        className="form-control p-l-15"
                        style={{ width: '50px' }}
                      >
                        {order}
                      </div>
                      <div className="input-group-append border">
                        <span
                          onClick={this.onOrderNumberEdit.bind(this, id, order)}
                          className="input-group-text d-flex justify-content-center align-items-center shadow-sm"
                        >
                          <i className="f-20 bg-white p-2 icofont icofont-ui-edit text-custom"></i>
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )
          },
        },
      },
      {
        name: 'name_en',
        label: 'Name English',
        options: { filter: false, sort: true },
      },
      {
        name: 'name_ar',
        label: 'Name Arabic',
        options: { filter: false, sort: true },
      },
      {
        name: 'image',
        label: 'Image',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (value) => {
            return (
              <>
                <img
                  src={Constant.getImage() + value}
                  className="img-fluid img-100"
                  alt="img"
                  onError={(event) => {
                    event.currentTarget.src = './assets/images/no_image.png'
                  }}
                />
              </>
            )
          },
        },
      },
      {
        name: 'is_active',
        label: 'Status',
        options: {
          filter: true,
          sort: true,
          customBodyRender: (is_active, tableMeta) => {
            return (
              <Toggle
                id={'is_active' + tableMeta.rowData[0]}
                checked={is_active}
                onChange={this.handleStatusChange.bind(this, tableMeta.rowData[0], !is_active)}
              />
            )
          },
        },
      },
      {
        name: 'id',
        label: 'Actions',
        options: {
          filter: false,
          sort: true,
          customBodyRender: (id) => {
            return (
              <div className="d-flex justify-content-start">
                <div>
                  <Link to={`/trips/edit/${id}`}>
                    <i className="f-20 icofont icofont-ui-edit text-custom m-r-10"></i>
                  </Link>
                </div>
                <div
                  onClick={() => {
                    this.delete(id)
                  }}
                >
                  <i className="f-20 icofont icofont-delete-alt text-danger"></i>
                </div>
                {/* <span
                  onClick={this.onPushClick.bind(this, id)}
                  className="m-r-15 text-muted"
                  data-toggle="tooltip"
                  data-placement="top"
                  title=""
                  data-original-title="Send Push"
                  style={{ cursor: 'pointer' }}
                >
                  <i className="f-20 icofont icofont-notification text-warning"></i>{' '}
                </span> */}
                <ActivitiesController refId={id}>Activities</ActivitiesController>
              </div>
            )
          },
        },
      },
    ]

    const options = {
      viewColumns: false,
      print: false,
      download: false,
      selectableRows: false,
      filter: false,
      search: false,
      textLabels: {
        body: {
          noMatch: this.state.isListLoading ? <Loader open={this.state.isListLoading} /> : 'Sorry, No Record Found',
          columnHeaderTooltip: (column) => `Sort for ${column.label}`,
        },
      },
    }

    return (
      <div className="pcoded-inner-content">
        <Modal
          open={this.state.isModalOpen}
          onClose={this.onModalClose}
          center
        >
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Title</label>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      className="form-control"
                      name="pushTitle"
                      id="title"
                      placeholder="Title"
                      onChange={this.handleChange}
                      value={this.state.pushTitle}
                      maxLength="22"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <div className="form-group row">
                  <label className="col-sm-3 col-form-label">Message</label>
                  <div className="col-sm-9">
                    <textarea
                      type="text"
                      className="form-control"
                      name="pushMessage"
                      id="message"
                      placeholder="Message"
                      onChange={this.handleChange}
                      value={this.state.pushMessage}
                      rows="4"
                      cols="50"
                      maxLength="53"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="text-right col-6 offset-6">
                {this.state.isData ? (
                  <button
                    className="btn btn-grd-disabled mr-2"
                    disabled
                  >
                    Sending...!
                  </button>
                ) : (
                  <button
                    onClick={this.sendPush}
                    className="btn hor-grd btn-grd-inverse offset-1"
                  >
                    <i className="ti-save"></i>Send
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal>
        <div className="main-body">
          <div className="page-wrapper">
            <div className="page-header">
              <div className="row align-items-end">
                <div className="col-lg-8">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Trips List</h4>
                    </div>
                  </div>
                  <Link
                    to="/trips/add"
                    data-modal="modal-13"
                    className="btn btn-sm btn-inverse f-right"
                  >
                    <i className="icofont icofont-plus m-r-5"></i> Add Trip
                  </Link>
                </div>
                <div className="col-lg-4">
                  <div className="page-header-breadcrumb">
                    <ul className="breadcrumb-title">
                      <li className="breadcrumb-item">
                        <Link to="/">
                          <i className="feather icon-home"></i>{' '}
                        </Link>
                      </li>
                      <li className="breadcrumb-item active">Trips List</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="page-body">
              <div className="row">
                <div className="col-12">
                  <div className="card card-border-default">
                    <div className="card-block">
                      <div className="dt-responsive table-responsive">
                        <MUIDataTable
                          className="table-responsive"
                          data={this.state.list}
                          columns={columns}
                          options={options}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default TripList
